<template>
  <draggable v-model="mutableQuestions"
             handle=".handle">
    <transition-group>
      <div
        v-for="(item, index) in mutableQuestions"
        :key="`survey::q${index}`"
        class="surveyQuestions__question">
        <div class="surveyQuestions__label">
          Q{{ index + 1 }}: {{ item.questionText }}
        </div>
        <div class="surveyQuestions__buttonGroup">
          <div
            class="surveyQuestions__button handle"
            data-toggle="tooltip"
            data-placement="left"
            title="Hold click and drag to reorder">
            <font-awesome-icon :icon="['fal', 'arrows-v']"></font-awesome-icon> Reorder
          </div>
          <div class="surveyQuestions__button"
               @click="removeQuestion(index)">
            <font-awesome-icon :icon="['fal', 'trash-alt']"></font-awesome-icon> Remove
          </div>
        </div>
      </div>
    </transition-group>
  </draggable>
</template>
<script>
import Draggable from "vuedraggable";

export default {
  name: "SurveyQuestions",
  components: {
    Draggable,
  },
  props: {
    questions: {
      type: Array,
      default: () => null,
    },
    addedQuestions: {
      type: Array,
      default: () => null,
    },
  },
  data: () => ( {
    mutableQuestions: [],
  } ),
  watch: {
    mutableQuestions: {
      handler () {
        this.$emit( "on-questions-updated", this.mutableQuestions );
      },
      deep: true,
    },
    addedQuestions: {
      handler ( val ) {
        console.log( val );
      },
      deep: true,
    },
  },
  mounted () {
    if ( this.questions == null ) {
      console.warn( "todo: load questions" );
    } else {
      this.mutableQuestions = [...this.questions];
    }
  },
  methods: {
    removeQuestion ( index ) {
      const mutableQuestions = [...this.mutableQuestions];
      mutableQuestions.splice( index, 1 );
      this.mutableQuestions = mutableQuestions;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../Styles/utils/index.less";

.surveyQuestions {
  margin: 0 0 16px 0;

  &__question {
    font-weight: 200;
    font-style: normal;
    font-size: 16px;
    text-align: left;
    height: 40px;
    border-bottom: 1px solid @blue;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &:first-child {
      border-top: 1px solid @blue;
    }

    &:last-child {
      border-bottom: none;
    }

    &__label {
    }
  }

  &__buttonGroup {
    display: flex;
  }

  &__button {
    cursor: pointer;
    margin: 0 16px 0 0;

    &:last-child {
      margin: 0;
    }
  }
}
</style>
